import React, { useState } from 'react';
import { DoubleRightOutlined, PrinterOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Row, Radio, Input } from 'antd';
import { FoodSectionCombo } from './FoodSectionCombo';
import { Search_Food_Reserve_Api } from '../../API/FoodReserveApi';
import '../../assets/css/printA5.css';
// ⚠️ وارد کردن پکیج‌های صحیح تقویم شمسی
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// ======================================================================

// 💡 تابع کمکی برای تبدیل ارقام فارسی به انگلیسی در یک رشته (مانند رشته تاریخ)
const convertPersianToEnglishDigits = (str) => {
    if (!str) return str;
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    let output = str;
    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
    }
    return output;
};


export const KitchenComponent = ({ 
  setLoading, 
  showMessage, 
  categoryId,  // یک categoryId
  categoryIds, // لیست categoryIds
  categoryTitles, // عنوان‌ها (اختیاری)
  onBackClick 
}) => {
    // ======================================================================
    // تغییر مهم: حالا بازه تاریخ داریم
    const [dateRange, setDateRange] = useState([null, null]);           // [start, end]
    const [foodSectionId, setFoodSectionId] = useState(0);
    const [showType, setShowType] = useState(1);
    const [aggregated_ByFoods, setAggregated_ByFoods] = useState(null);
    const [aggregated_ByRooms, setAggregated_ByRooms] = useState(null);
const [rawReportData, setRawReportData] = useState([]);

    const showTypeChange = (e) => {
        setShowType(e.target.value);
        setAggregated_ByFoods(null);
        setAggregated_ByRooms(null);
    };
    // =================================================================
    const handleDateRangeChange = (dates) => {
        if (Array.isArray(dates) && dates.length === 2) {
            const [start, end] = dates;

            if (start?.isValid && end?.isValid) {
                let startStr = start.format('YYYY-MM-DD');
                let endStr   = end.format('YYYY-MM-DD');

                startStr = convertPersianToEnglishDigits(startStr);
                endStr   = convertPersianToEnglishDigits(endStr);

                setDateRange([startStr, endStr]);
            } else {
                setDateRange([null, null]);
            }
        } else {
            setDateRange([null, null]);
        }
    };
    // =================================================================
const submitSearch = async () => {
        const [startDate, endDate] = dateRange;

        // if (!startDate || !endDate ) {
        //     showMessage("لطفاً بازه تاریخ و وعده غذایی را انتخاب کنید.", "warning");
        //     return;
        // }

        if (!startDate || !endDate || (!categoryIds && !categoryId)  || (categoryIds.length === 0 && categoryId===0 )) {
            showMessage("لطفاً بازه تاریخ و حداقل یک دسته‌بندی را انتخاب کنید.", "warning");
            return;
        }

        try {
            setLoading(true);

            const params = {
                date_Shamsi_From: startDate,
                date_Shamsi_To: endDate,
                foodSectionId: foodSectionId,
                categoryId: categoryId,
                categoryIds: categoryIds, // تغییر به آرایه
                categoryTitles:categoryTitles,
            };

            // پاک کردن داده‌های قبلی
            setRawReportData([]);
            setAggregated_ByFoods(null);
            setAggregated_ByRooms(null);

            const data = await Search_Food_Reserve_Api(params);

            if (data.messageStatus === "Successful") {
                const rawData = data.messageData.data || [];

                // ۱. نگه داشتن داده خام برای چاپ
                setRawReportData(rawData);

                // ۲. محاسبه تجمیع برای نمایش روی صفحه (اختیاری - می‌توانید حذف کنید اگر فقط چاپ مهم است)
                if (showType === 1) {
                    const grouped = groupByRoom(rawData);
                    setAggregated_ByRooms(aggregateFoodsByRoom(grouped));
                } else if (showType === 2) {
                    setAggregated_ByFoods(aggregateData_ByFoods(rawData));
                }
            } else {
                showMessage(data.message, "error");
            }
        } catch (error) {
            showMessage(error.message || "خطا در دریافت اطلاعات", "error");
        } finally {
            setLoading(false);
        }
    };

    // ─── تابع جدید برای آماده‌سازی داده چاپ ─────────────────────────────
    const getPrintData = () => {
        return rawReportData
            .map((item, index) => ({
                row: index + 1,
                date: item.date_Shamsi?.replace(/-/g, "/") || "—", // تبدیل به فرمت 1404/05/15
                room: item.objectInstanceTitle || "—",
                foodSection: item.persionFoodSection || "—",   // اگر API این فیلد را دارد
                food: item.foodTitle || "—",
                count: item.count || 0,
                description: item.description || "—",        // اگر فیلد توضیحات دارید
            }))
            // .sort((a, b) => {
            //     // مرتب‌سازی: اول بر اساس تاریخ، بعد اتاق، بعد غذا
            //     if (a.date !== b.date) return a.date.localeCompare(b.date);
            //     if (a.room !== b.room) return a.room.localeCompare(b.room, 'fa');
            //     return a.food.localeCompare(b.food, 'fa');
            // });
    };
            // =================================================================


const aggregateData_ByFoods = (data) => {
    const aggregated = {};

    data.forEach(item => {
        // کلید منحصربه‌فرد: ترکیب foodMealId + foodTitle
        // const key = `${item.foodMealId || 0}|||${item.foodTitle || 'بدون عنوان'}`;
 const key = `${item.date_Shamsi || 0}|||${item.persionFoodSection || 0}|||${item.foodTitle || 'بدون عنوان'}`;

        if (!aggregated[key]) {
            aggregated[key] = {
                foodMealId: item.foodMealId || 0,               // ← اینجا f با حرف بزرگ M
                date_Shamsi : item.date_Shamsi || '—',
                persionFoodSection: item.persionFoodSection || '—',
                foodTitle: item.foodTitle || '—',
                totalCount: 0
            };
        }

        aggregated[key].totalCount += Number(item.count) || 0;
    });

    const result = Object.values(aggregated);

    // مرتب‌سازی: اول بر اساس FoodMealId (عددی)، سپس بر اساس نام غذا (فارسی)
    result.sort((a, b) => {
        // اگر FoodMealId متفاوت بود → بر اساس عدد مرتب کن
        if (a.foodMealId !== b.foodMealId) {
            return a.foodMealId - b.foodMealId;           // صعودی
            // برای نزولی:   return b.FoodMealId - a.FoodMealId;
        }

        // اگر FoodMealId یکسان بود → بر اساس نام غذا (الفبای فارسی)
        return a.foodTitle.localeCompare(b.foodTitle, 'fa');
    });

    return result;
};

    // =================================================================
    const groupByRoom = (data) => {
        const grouped = {};

        data.forEach(item => {
            if (!grouped[item.objectInstanceTitle]) {
                grouped[item.objectInstanceTitle] = [];
            }
            grouped[item.objectInstanceTitle].push(item);
        });

        return grouped;
    };
    // =================================================================
    const aggregateFoodsByRoom = (groupedData) => {
        const result = {};

        Object.keys(groupedData).forEach(room => {
            const aggregated = {};

            groupedData[room].forEach(item => {
                if (!aggregated[item.foodTitle]) {
                    aggregated[item.foodTitle] = 0;
                }
                aggregated[item.foodTitle] += item.count;
            });

            result[room] = aggregated;
        });

        return result;
    };
    // =================================================================
// ۱. گروه‌بندی داده‌های خام بر اساس نام اتاق
const groupedByRoomForPrint = () => {
  const grouped = {};

  rawReportData.forEach(item => {
    const room = item.objectInstanceTitle || 'نامشخص';

    if (!grouped[room]) {
      grouped[room] = [];
    }
    grouped[room].push(item);
  });

  // اختیاری: مرتب‌سازی داخل هر اتاق (مثلاً بر اساس تاریخ)
//   Object.values(grouped).forEach(records => {
//     records.sort((a, b) => {
//       if (a.date_Shamsi !== b.date_Shamsi) {
//         return a.date_Shamsi.localeCompare(b.date_Shamsi);
//       }
//       return (a.foodTitle || '').localeCompare(b.foodTitle || '', 'fa');
//     });
//   });

  return grouped;
};

// ۲. فرمت تاریخ (اگر لازم است خط تیره را به اسلش تبدیل کنی)
const formatShamsiDate = (dateStr) => {
  if (!dateStr) return '—';
  return dateStr.replace(/-/g, '/');
};

const PAGE_CONFIG = {
  A4: {
    pageHeight: 297,
    rowsPerPage: 28,
    fontSize: 12
  },
  A5: {
    pageHeight: 210,
    rowsPerPage: 18,
    fontSize: 10
  }
};
 const pageSize = 'A5'; // یا از props / state
// const pageSize = selectedSize; // 'A4' یا 'A5'
const { rowsPerPage, fontSize } = PAGE_CONFIG[pageSize];
const paginate = (data, size) => {
  const pages = [];
  for (let i = 0; i < data.length; i += size) {
    pages.push(data.slice(i, i + size));
  }
  return pages;
};

const pages = paginate(getPrintData(), rowsPerPage);

// const PrintComponent = ({ selectedSize }) => {
//   const pageSize = selectedSize || 'A5';
// }


const totalCount = rawReportData.reduce(
  (sum, r) => sum + (r.count || 0),
  0
);
    // =================================================================

    return (
        <>
        <div className="no-print">
            <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button
                        className='step-prev-btn btn-light'
                        onClick={() => { onBackClick() }}
                    >
                        <DoubleRightOutlined />
                        <span className='step-prev-btn-title'>
                            بازگشت
                        </span>
                    </Button>

                </Col>
                <Col xs={10} sm={10} md={10} lg={16} xl={16}>
                    <h2>
                        گزارشات آشپزخانه
                    </h2>
                </Col>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "left" }} >
                    <Button
                        className={'step-next-btn btn-primary'}
                        onClick={() => { window.print() }}
                    >
                        <span className='step-next-btn-title'>
                            چاپ
                        </span>
                        <PrinterOutlined />
                    </Button>
                </Col>
            </Row>
            
{categoryTitles && (
  <div style={{ 
    margin: '10px 0', 
    padding: '10px', 
    backgroundColor: '#f0f8ff', 
    borderRadius: '4px',
    textAlign: 'center',
    fontWeight: 'bold'
  }}>
    <span>دسته‌بندی‌های انتخاب شده: </span>
    <span style={{ color: '#1890ff' }}>{categoryTitles}</span>
    <span style={{ marginRight: '10px', fontSize: '12px', color: '#666' }}>
      ({categoryIds.length} مورد)
    </span>
  </div>
)}
            <div className='container'>
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={12} sm={2} md={2} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                        بازه تاریخ:
                    </Col>
                    <Col xs={12} sm={10} md={10} lg={8} xl={8}>
                        <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            range
                            numberOfMonths={2}           // اختیاری: دو تقویم کنار هم
                            calendarPosition="bottom-right"
                            format="YYYY-MM-DD"
                            onChange={handleDateRangeChange}
                            render={
                                <Input
                                    placeholder="از تاریخ - تا تاریخ"
                                    style={{ width: '100%' }}
                                    value={
                                        dateRange[0] && dateRange[1]
                                            ? `${dateRange[0]} تا ${dateRange[1]}`
                                            : ''
                                    }
                                    readOnly={true}
                                />
                            }
                        />
                    </Col>

                    <Col xs={24} sm={1} md={1} lg={1} xl={1} />

                    <Col xs={12} sm={3} md={3} lg={3} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                        وعده غذایی:
                    </Col>

                    <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                        <FoodSectionCombo
                            onChange={(id) => setFoodSectionId(id)}
                        />
                    </Col>

                    <Col xs={24} sm={1} md={1} lg={1} xl={1} />
                    <Col xs={12} sm={9} md={9} lg={9} xl={9}>
                        <Radio.Group onChange={showTypeChange} value={showType} style={{ width: '100%' }}>
                            <Row justify='start' style={{ paddingTop: '8px', paddingBottom: '8px' }}>
                                <Col span={12}>
                                    <Radio value={1}>به تفکیک اتاق</Radio>
                                </Col>

                                <Col span={12}>
                                    <Radio value={2}>به تفکیک غذا</Radio>
                                </Col>
                            </Row>
                        </Radio.Group>
                    </Col>
                </Row>
            </div>
           <Row style={{ padding: '10px' }}>
                <Col span={20}></Col>
                <Col span={4}>
                    <Button
                        className='btn-success'
                        onClick={submitSearch}
                        style={{ width: '95%' }}
                        disabled={!dateRange[0] || !dateRange[1] }
                    >
                        <SearchOutlined /> جستجو
                    </Button>
                </Col>
            </Row>

            {/* بخش نمایش گزارش به تفکیک اتاق */}
            
      {/* اینجا محتوای معمولی صفحه است (جستجو، Radio ها، جدول تجمیعی و ...) */}
      {/* ... کد قبلی شما ... */}
   
{showType === 1 && aggregated_ByRooms && rawReportData?.length > 0 ? (
  <div style={{ padding: '20px', fontFamily: 'IRANSans, Tahoma, sans-serif' }}>
    {Object.entries(groupedByRoomForPrint()).map(([roomName, records]) => (
      <div
        key={roomName}
        style={{ marginBottom: '30px', border: '1px solid #ddd', borderRadius: '4px' }}
      >
        <Row className="sectionTitle" style={{ marginBottom: '0', backgroundColor: '#f5f5f5' }}>
          <Col span={24} style={{ padding: '10px' }}>
            <h3 style={{ margin: 0 }}>{roomName}</h3>
          </Col>
        </Row>

        <div className="container factor">
          <Row
            className="titleRow"
            style={{ fontWeight: 'bold', backgroundColor: '#e9e9e9', borderBottom: '1px solid #ddd' }}
          >
            <Col span={6} style={{ padding: '8px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
              تاریخ
            </Col>
            <Col span={6} style={{ padding: '8px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
              وعده غذایی
            </Col>
            <Col span={8} style={{ padding: '8px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
              نام غذا
            </Col>
            <Col span={4} style={{ padding: '8px', textAlign: 'center' }}>
              تعداد
            </Col>
          </Row>

          {records.map((item, index) => (
            <Row
              className="valueRow"
              key={`${roomName}-${index}`}
              style={{ borderBottom: '1px solid #eee' }}
            >
              <Col span={6} style={{ padding: '8px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
                {formatShamsiDate(item.date_Shamsi)}
              </Col>
              <Col span={6} style={{ padding: '8px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
                {item.persionFoodSection || '—'}
              </Col>
              <Col span={8} style={{ padding: '8px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
                {item.foodTitle || '—'}
              </Col>
              <Col span={4} style={{ padding: '8px', textAlign: 'center' }}>
                {item.count || 0}
              </Col>
            </Row>
          ))}
        </div>
      </div>
    ))}
  </div>
) : null}
            {/* بخش نمایش گزارش به تفکیک غذا */}
            {showType === 2 && aggregated_ByFoods ?
                <>
                    <div className='container factor' style={{ padding: '20px', fontFamily: 'IRANSans, Tahoma, sans-serif' }}>
                        <Row className="titleRow" style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', borderBottom: '1px solid #ddd' }}>
                            <Col span={5} style={{ padding: '10px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
        تاریخ
      </Col>
                            <Col span={5} style={{ padding: '10px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
        وعده غذایی
      </Col>
      <Col span={10} style={{ padding: '10px', borderLeft: '1px solid #ddd', textAlign: 'right' }}>
        نام غذا
      </Col>
      <Col span={4} style={{ padding: '10px', textAlign: 'center' }}>
        تعداد کل
      </Col>
                        </Row>


                        {aggregated_ByFoods.map((item, index) => (
                            <Row className="valueRow" key={index} style={{ borderBottom: '1px solid #eee' }}>
                                <Col span={5} style={{ padding: '10px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
          {item.date_Shamsi}
        </Col>
                                <Col span={5} style={{ padding: '10px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
          {item.persionFoodSection}
        </Col>
        <Col span={10} style={{ padding: '10px', borderLeft: '1px solid #eee', textAlign: 'right' }}>
          {item.foodTitle}
        </Col>
        <Col span={4} style={{ padding: '10px', textAlign: 'center' }}>
          {item.totalCount}
        </Col>
                            </Row>

                        ))}
                    </div>
                </> : null
            }
             </div>

                {/* بخش چاپ گزارش به تفکیک اتاق */}
{rawReportData.length > 0 && aggregated_ByRooms && (
  <div className="only-print">
    <div className={`print-root ${pageSize}`}>

      {pages.map((pageRows, pageIndex) => (
        <div key={pageIndex} className="print-page">

      <h2 style={{ textAlign: 'center', marginBottom: '1cm' }}>
        گزارش رزرو غذا – به تفکیک اتاق
      </h2>

      <div style={{ textAlign: 'center', marginBottom: '1.2cm' }}>
        بازه زمانی: {dateRange[0]?.replace(/-/g, '/')} تا {dateRange[1]?.replace(/-/g, '/')}  
            |     وعده: {rawReportData[0]?.foodSectionTitle || 'مشخص نشده'}
      </div>

      {/* جدول */}
      <table style={{ 
        width: '100%', 
        borderCollapse: 'collapse', 
        marginBottom: '1cm',               // ← فاصله کمتر قبل از فوتر
        pageBreakInside: 'auto'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'center', width: '50px' }}>ردیف</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'center', width: '85px' }}>تاریخ</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'right' }}>نام اتاق</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'right' }}>وعده غذایی</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'right' }}>نام غذا</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'center', width: '65px' }}>تعداد</th>
            <th style={{ border: '1px solid #999', padding: '7px 5px', textAlign: 'right' }}>توضیحات</th>
          </tr>
        </thead>

        <tbody>
              {pageRows.map((row) => (
                <tr key={row.row}>
              
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'center' }}>{row.row}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'center' }}>{row.date}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'right' }}>{row.room}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'right' }}>{row.foodSection}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'right' }}>{row.food}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'center' }}>{row.count}</td>
              <td style={{ border: '1px solid #ccc', padding: '6px 5px', textAlign: 'right' }}>{row.description || '—'}</td>
            </tr>
          ))}
        </tbody>
        {/* فوتر جدول - فقط یک بار در انتها می‌آید، اما اگر جدول چند صفحه‌ای باشد، در صفحه آخر می‌ماند */}
      </table>
{pageIndex === pages.length - 1 && (
            <div className="print-footer">
              <div>تعداد کل ردیف‌ها: {rawReportData.length}</div>
              <div>تعداد کل پرس غذا: {totalCount}</div>
              <div>امضاء</div>
            </div>
          )}

        </div>
      ))}

    </div>
  </div>
)}





{rawReportData.length > 0 && aggregated_ByFoods && (
  <>
    {/* 
      محتوای اصلی صفحه (جستجو، جدول‌های روی صفحه و ...) 
      باید کلاس no-print بگیرند تا در چاپ مخفی شوند 
    */}

    {/* مثال: فرض کنیم کل بخش جستجو و جدول‌های معمولی داخل یک div هستند */}
<div className="only-print">
      <div className="container">
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
          گزارش رزرو غذا – به تفکیک غذا
        </h2>

        <p style={{ textAlign: 'center', marginBottom: '20px', fontSize: '14px' }}>
          بازه زمانی: {dateRange[0]?.replace(/-/g, '/')} تا {dateRange[1]?.replace(/-/g, '/')}  
              |     وعده: {rawReportData[0]?.foodSectionTitle || 'مشخص نشده'}
        </p>

        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
<thead>
          <tr style={{ backgroundColor: '#e8e8e8', fontWeight: 'bold' }}>
            <th style={{ border: '1px solid #aaa', padding: '8px 10px', width: '60px', textAlign: 'center' }}>
              ردیف
            </th>
            <th style={{ border: '1px solid #aaa', padding: '8px 10px', textAlign: 'right' }}>
              تاریخ
            </th>
            <th style={{ border: '1px solid #aaa', padding: '8px 10px', textAlign: 'right' }}>
              وعده
            </th>
            <th style={{ border: '1px solid #aaa', padding: '8px 10px', textAlign: 'right' }}>
              غذا
            </th>
            <th style={{ border: '1px solid #aaa', padding: '8px 10px', width: '90px', textAlign: 'center' }}>
              تعداد
            </th>
          </tr>
        </thead>

        <tbody>
          {aggregated_ByFoods.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ccc', padding: '7px', textAlign: 'center' }}>
                {index + 1}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '7px 10px', textAlign: 'right' }}>
                {item.date_Shamsi || '—'}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '7px 10px', textAlign: 'right' }}>
                {item.persionFoodSection || '—'}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '7px 10px', textAlign: 'right' }}>
                {item.foodTitle || '—'}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '7px', textAlign: 'center', fontWeight: 'bold' }}>
                {item.totalCount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* جمع کل (اختیاری) */}
      <div style={{ marginTop: '20px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>
        جمع کل: {aggregated_ByFoods.reduce((sum, item) => sum + item.totalCount, 0)} پرس
      </div>

      {/* تاریخ چاپ (اختیاری) */}
      <div style={{ marginTop: '30px', textAlign: 'center', fontSize: '11px', color: '#555' }}>
        چاپ شده در: {new Date().toLocaleDateString('fa-IR')}
      </div>
            </div>
    </div>
  </>
)}
        </>
    );
};
       